module.exports = __webpack_public_path__ + "static/media/FAQ-PinkWave.0da32cab.svg";